import _ from 'lodash';
import AccountsStore from '../stores/AccountsStore';

class AccountReorderParser {
  getOrderedChangedAccounts(requestData) {
    const changedAccounts = [];
    _.map(requestData, (data) => {
      // SEND only data whose order are changed or has not been set earlier
      if (data.display_order !== data.metadata.display_order) {
        const account = {
          id: data.id,
          display_order: data.display_order,
          display_name: data.displayName,
        };
        changedAccounts.push(account);
      }
    });
    return changedAccounts;
  }

  accountListErrorFlag() {
    return AccountsStore.getErrorFlag(); // NOT sure why this kept
  }

  accountListLoaderFlag() {
    return AccountsStore.getLoad();
  }
}

export default new AccountReorderParser();
